import { Observable, shareReplay, finalize, map } from 'rxjs';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

let inFlightRefresh$: Observable<string> | null = null;

/**
 * Single-flights refresh-token calls: concurrent callers share one in-flight
 * request and all receive its success value or its error, instead of each
 * triggering their own /refresh-token call.
 */
export function getFreshAccessToken(
  authenticationService: AuthenticationService,
  refreshToken: string
): Observable<string> {
  if (inFlightRefresh$) {
    return inFlightRefresh$;
  }

  inFlightRefresh$ = authenticationService.refreshToken(refreshToken).pipe(
    map((res: any) => res.accessToken as string),
    // finalize must wrap the source (before shareReplay), so it fires once when the
    // single underlying HTTP call terminates — not once per external subscriber, which
    // would let an early unsubscribe by one caller reset the single-flight state while
    // another caller is still waiting on it.
    finalize(() => {
      inFlightRefresh$ = null;
    }),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  return inFlightRefresh$;
}
